import { useAccount, useChainId, useDisconnect, useSwitchChain } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { ChevronDown, ExternalLink } from "lucide-react";
import { Menu, Box, Button, Flex, Link, Text } from "@chakra-ui/react";
import { BoldText } from "../../Components/UI/UIHelpers";
import { shortenAddress } from "../../Utils/Helpers";
import { networkNameByNetworkId, networkIds } from "../../chainbridgeConfig";
import { getFeatureFlagStatus } from "../../featureFlags";

const walletExtendedActionsEnabled = getFeatureFlagStatus(
  "walletExtendedActionsEnabled"
);
const trackerUrl = import.meta.env.VITE_TRACKER_URL;
const networks = networkIds();

export const UserProfile = () => {
  const { address } = useAccount();
  const chainId = useChainId();
  const { openConnectModal } = useConnectModal();
  const { disconnect } = useDisconnect();
  const { switchChain } = useSwitchChain();

  const changeNetwork = () => {
    const targetChainId = chainId === networks[1] ? networks[0] : networks[1];
    switchChain({ chainId: targetChainId });
  };

  const isUnsupportedNetwork = (): boolean => {
    return !!chainId && networkNameByNetworkId(chainId) === "Unsupported";
  };

  return (
    <>
      <Box>
        {!address ? (
          <Button onClick={openConnectModal}>Connect Wallet</Button>
        ) : (
          <Menu.Root>
            <Menu.Trigger asChild>
              <Button fontSize="12px" p={0} variant="outline">
                <Flex alignItems="center" py="8px" px="10px">
                  <Box
                    w="10px"
                    h="10px"
                    bgColor={
                      isUnsupportedNetwork()
                        ? "palmNetwork.900"
                        : "palmNetwork.1000"
                    }
                    borderRadius="50%"
                    mr="10px"
                  />
                  <BoldText>{address && shortenAddress(address)}</BoldText>
                  <ChevronDown size={20} style={{ marginRight: "8px" }} />
                </Flex>
              </Button>
            </Menu.Trigger>
            <Menu.Positioner>
              <Menu.Content borderRadius="0px" border="1px solid" width="100%">
                {chainId && (
                  <Text
                    p={1}
                    px={3}
                    color={
                      isUnsupportedNetwork()
                        ? "palmNetwork.900"
                        : "palmNetwork.1000"
                    }
                  >
                    Network: {networkNameByNetworkId(chainId)}
                  </Text>
                )}
                {address && (
                  <Menu.Item value="transactions">
                    <Link
                      href={`${trackerUrl}?address=${address}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      My Transfers <ExternalLink size={14} />
                    </Link>
                  </Menu.Item>
                )}
                {walletExtendedActionsEnabled && (
                  <Menu.Item value="reset-wallet">
                    <span onClick={() => disconnect()}>Disconnect Wallet</span>
                  </Menu.Item>
                )}
                {walletExtendedActionsEnabled && (
                  <Menu.Item value="change-config">
                    <span onClick={changeNetwork}>Change Network</span>
                  </Menu.Item>
                )}
              </Menu.Content>
            </Menu.Positioner>
          </Menu.Root>
        )}
      </Box>
    </>
  );
};
